"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgPrevious = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("g", { clipPath: "url(#previous_svg__clip0)" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M12.51 0c-6.609 0-12 5.39-12 12s5.391 12 12 12c6.61 0 12-5.39 12-12s-5.39-12-12-12zm6 12.984H8.949l2.297 2.297a1.02 1.02 0 010 1.406 1.033 1.033 0 01-.703.282c-.234 0-.516-.094-.703-.282l-3.985-3.984a1.02 1.02 0 010-1.406L9.84 7.312a1.02 1.02 0 011.406 0 1.02 1.02 0 010 1.407l-2.297 2.297h9.563a.99.99 0 01.984.984c0 .516-.469.984-.984.984z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "previous_svg__clip0" },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z", transform: "translate(.51)" })))));
};
exports.default = SvgPrevious;
//# sourceMappingURL=Previous.js.map